import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import startCase from 'lodash/startCase';

// GLOBAL FUNCTIONS
import { apiFetch } from 'functions.js';

// CONTEXT
import { useLogContext } from '../helpers/logContext';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// STYLES
import styles from './deleteButton.module.scss';

// MAIN COMPONENT
const DeleteButton = ({
  name,
  className,
  label = 'comment',
  args = {}
}) => {

  // CONTEXT
  const { logs: { [name]: { fetch } = {} } } = useLogContext() || {};

  // CALLBACKS
  const handleDelete = () => {
    apiFetch({
      method: 'DELETE',
      onSuccess: () => fetch(),
      loadingMessage: `Deleting ${label}`,
      successMessage: `${startCase(label)} deleted.`,
      errorMessage: `Unable to delete ${label}.`,
      ...args
    });
  };

  // RENDER
  return (
    <Button.Link
      className={clsx(
        styles.deleteButton,
        className
      )}
      icon="trash"
      onClick={handleDelete}
      square
    />
  );
};

// EXPORT
export default DeleteButton;
